// DirtyValue.tsx — one value as text, struck through when a dirty mark
// covers it.
//
// The strikethrough is the required cue (dirty.ts, rule 2); fading rides on
// top. The marks' reasons are the hover title, and the aria-label says
// "<text>, dirty: <reason>" so a screen reader hears the state too. A clean
// value renders as plain text, so call sites use this unconditionally.
import type { DirtyRef } from '../api';
import { DIRTY_STYLE, dirtyLabel, dirtyTitle } from './dirty';

export default function DirtyValue({ text, dirty, marks, className }: {
  text: string;
  dirty?: boolean;
  marks?: DirtyRef[];
  className?: string;
}) {
  if (!dirty) return <span className={className}>{text}</span>;
  return (
    <span
      className={['dirty-value', className].filter(Boolean).join(' ')}
      style={DIRTY_STYLE}
      title={dirtyTitle(marks) || dirtyLabel(marks)}
      aria-label={`${text}, ${dirtyLabel(marks)}`}
    >
      {text}
    </span>
  );
}
